/** a small element builder: el('button', { class: 'x', onclick }, 'label', child) */
type Child = Node | string | number | null | undefined | false;
type Attrs = Record<string, string | number | boolean | EventListener | undefined | null>;

export function el<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === null || v === false) continue;
    if (k.startsWith('on') && typeof v === 'function') e.addEventListener(k.slice(2).toLowerCase(), v);
    else if (k === 'class') e.className = String(v);
    else if (v === true) e.setAttribute(k, '');
    else e.setAttribute(k, String(v));
  }
  for (const c of children) {
    if (c === null || c === undefined || c === false) continue;
    e.append(c instanceof Node ? c : String(c));
  }
  return e;
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

/** a short message that fades; one at a time per host */
export function toast(host: HTMLElement, text: string, kind: 'ok' | 'bad' | 'info' = 'info', ms = 1400): void {
  host.querySelector('.toast')?.remove();
  const t = el('div', { class: `toast toast-${kind}` }, text);
  host.append(t);
  requestAnimationFrame(() => t.classList.add('show'));
  setTimeout(() => {
    t.classList.remove('show');
    setTimeout(() => t.remove(), 250);
  }, ms);
}

/** on-screen event log, only when the page is opened with ?debug (reading adb-driven phones) */
let dbg: HTMLPreElement | null = null;
export function debugLog(msg: string): void {
  if (!location.search.includes('debug')) return;
  if (!dbg) {
    dbg = el('pre', { class: 'dbg' });
    document.body.append(dbg);
  }
  dbg.textContent = `${msg}\n${dbg.textContent ?? ''}`.split('\n').slice(0, 14).join('\n');
}
